/* globals translation */

const initShippingZipCode = () => {
  const zipCodeField = document.getElementById('custom-zip-code-field');

  if (!zipCodeField) {
    return;
  }

  let zipCodeLength = 4;

  if (!document.body.classList.contains('user-shipping-country-no')) {
    zipCodeLength = 5;
  }

  zipCodeField.addEventListener('keyup', () => {
    if (zipCodeField.value.length === zipCodeLength) {
      zipCodeField.blur();
      document.body.classList.add('loading');

      const payload = {
        action: 'maksimer_zip_code_customer_set',
        postcode: zipCodeField.value,
      };

      jQuery.post(translation.ajaxurl, payload, (result) => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      });
    }
  });
};

const initOrderTableToggle = () => {
  const toggleButton = document.getElementById('toggle-order-table-display');
  toggleButton.addEventListener('click', (event) => {
    event.preventDefault();
    document.body.classList.add('display-order-table');
  });
};

jQuery(document.body).on('updated_checkout', initShippingZipCode);
jQuery(document.body).on('updated_checkout', initOrderTableToggle);


jQuery(document.body).on('kco_shipping_address_changed', (event, data) => {
  console.log(event);
  console.log(data);
});
